export const AUCTION_API_URL =
  process.env.REACT_APP_AUCTION_API_URL ||
  `${process.env.REACT_APP_BASE_URL}/auction`

export async function parseJsonResponse (res) {
  const text = await res.text()

  if (!text) {
    return {}
  }

  try {
    return JSON.parse(text)
  } catch (_) {
    throw new Error(res.ok ? 'Invalid server response' : `Request failed (${res.status})`)
  }
}

export async function fetchLatestBid () {
  const res = await fetch(AUCTION_API_URL, { cache: 'no-store' })
  const data = await parseJsonResponse(res)

  if (!res.ok) {
    throw new Error(data.message || 'Failed to fetch bid')
  }

  if (data.bidAmount == null) {
    throw new Error('Bid amount is unavailable')
  }

  return data
}

export async function updateBid ({ email, bidAmount }) {
  const res = await fetch(AUCTION_API_URL, {
    method: 'PUT',
    cache: 'no-store',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, bidAmount })
  })

  const data = await parseJsonResponse(res)

  if (!res.ok) {
    throw new Error(data.message || `Update failed (${res.status})`)
  }

  if (data.bidAmount == null) {
    throw new Error('Update succeeded but bid amount is missing from the response')
  }

  return data
}
